import Browsers from "./Browsers";
import CertificateAccess from "./CertificateAccess";
import Login from "./Login";

export default {
  Login,
  Browsers,
  CertificateAccess
}